import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import FileUpload from "./FileUpload";
import { toast } from "sonner";

const inputCls = "w-full bg-transparent border-b border-black/15 focus:border-[#0060A7] outline-none py-2";
const textareaCls = "w-full bg-white border border-black/15 focus:border-[#0060A7] outline-none p-3 text-sm leading-relaxed";

export default function AdminWelcome() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/welcome").then((r) => setData(r.data || {})).catch(() => setData({}));
    }, []);

    if (!data) return <div className="text-[#6B7280]">…</div>;

    const update = (k, v) => setData({ ...data, [k]: v });

    const save = async () => {
        try {
            await api.put("/admin/welcome", data);
            toast.success("Saved");
        } catch (e) { toast.error(formatApiError(e)); }
    };

    return (
        <div data-testid="admin-welcome-page">
            <h1 className="heading text-2xl tracking-tight mb-2 font-bold">Welcome Message Page</h1>
            <p className="text-sm text-[#6B7280] mb-6">يمكنك تحرير نص كلمة الترحيب، تغيير صورة المؤسس، وإخفاء الصفحة بالكامل من الموقع.</p>

            <div className="bg-white p-8 max-w-4xl space-y-6">
                <FileUpload value={data.photo || ""} onChange={(v) => update("photo", v)} label="Founder Photo" testid="welcome-photo-upload" />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border-t border-black/10 pt-6">
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Page Title (AR)</label>
                        <input className={inputCls} value={data.title_ar || ""} onChange={(e) => update("title_ar", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Page Title (EN)</label>
                        <input className={inputCls} value={data.title_en || ""} onChange={(e) => update("title_en", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Intro line (AR)</label>
                        <input className={inputCls} value={data.intro_ar || ""} onChange={(e) => update("intro_ar", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Intro line (EN)</label>
                        <input className={inputCls} value={data.intro_en || ""} onChange={(e) => update("intro_en", e.target.value)} />
                    </div>
                    <div className="md:col-span-2">
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Body (AR) — use empty lines for paragraphs</label>
                        <textarea rows={10} className={textareaCls} value={data.body_ar || ""} onChange={(e) => update("body_ar", e.target.value)} data-testid="welcome-body-ar" />
                    </div>
                    <div className="md:col-span-2">
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Body (EN)</label>
                        <textarea rows={10} className={textareaCls} value={data.body_en || ""} onChange={(e) => update("body_en", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Signature Name (AR)</label>
                        <input className={inputCls} value={data.signature_name_ar || ""} onChange={(e) => update("signature_name_ar", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Signature Name (EN)</label>
                        <input className={inputCls} value={data.signature_name_en || ""} onChange={(e) => update("signature_name_en", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Signature Title (AR)</label>
                        <input className={inputCls} value={data.signature_title_ar || ""} onChange={(e) => update("signature_title_ar", e.target.value)} />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Signature Title (EN)</label>
                        <input className={inputCls} value={data.signature_title_en || ""} onChange={(e) => update("signature_title_en", e.target.value)} />
                    </div>
                </div>

                <label className="inline-flex items-center gap-3 text-sm border-t border-black/10 pt-6">
                    <input type="checkbox" checked={!!data.published} onChange={(e) => update("published", e.target.checked)} data-testid="welcome-published" />
                    Show page on public site
                </label>
            </div>

            <button onClick={save} data-testid="welcome-save" className="mt-6 bg-[#002951] hover:bg-[#0060A7] text-white px-8 py-3 text-sm uppercase tracking-[0.2em]">Save</button>
        </div>
    );
}
